import React from "react";

import { Checkbox, FormField, Text } from "@performyard/py-components";

import { GridCol } from "../../../../components/Grid";
import Spacer from "../../../../components/Spacer";

type CheckboxOption = {
	value: string;
	label: string;
	dataTestId?: string;
};

type CheckboxGroupProps = {
	title: string;
	description: string;
	options: CheckboxOption[];
};

export const CheckboxGroup = ({ title, description, options }: CheckboxGroupProps) => {
	return (
		<GridCol span={5}>
			<Text size="paragraph-2" weight="semi-bold" color="neutral-9">
				{title}
			</Text>
			<Spacer height={1} />
			<div>
				<Text size="paragraph-3" weight="regular" color="neutral-9">
					{description}
				</Text>
			</div>

			{options.map((option) => (
				<React.Fragment key={option.value}>
					<Spacer height={2} />
					<FormField<boolean>
						id={option.value}
						label={option.label}
						labelPosition="right"
						dangerouslySetClassName="gap-4"
						input={(field) => {
							return (
								<Checkbox
									id={option.value}
									aria-labelledby={`label-${option.value}`}
									onCheckedChange={() => {
										field.onChange(!field.value);
									}}
									checked={field.value}
									data-testid={option.dataTestId}
								/>
							);
						}}
					/>
				</React.Fragment>
			))}
		</GridCol>
	);
};
